import { withFilters } from 'coreOld/components';
import { IFiltersProps } from 'coreOld/types';
import { getListPayload } from 'coreOld/utils';
import { useGetQuoteHistory } from 'partsOld/hooks';
import { ICompanyPart } from 'partsOld/types';

import HistoryListView from './HistoryListView';

interface IProps extends IFiltersProps {
  part: Partial<ICompanyPart>;
}

const getPayload = (part: Partial<ICompanyPart>) => {
  return getListPayload({ partNumber: part?.part, manufacturerId: part?.manufacturerId });
};

const HistoryList = ({ part, filters }: IProps) => {
  const requestPayload = getPayload(part);

  const { records, fetchNextPage, hasNextPage, isLoading, isFetchingNextPage } = useGetQuoteHistory(
    {
      ...requestPayload,
      filters: { ...requestPayload.filters, ...filters },
    }
  );

  return (
    <HistoryListView
      records={records}
      isLoading={isLoading}
      isFetchingNextPage={isFetchingNextPage}
      hasNextPage={hasNextPage}
      fetchNextPage={fetchNextPage}
    />
  );
};

export default withFilters(HistoryList);
